/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Support({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M7.95.75a6 6 0 0 1 5.82 4.545c.995.214 1.68 1.174 1.68 2.223V9.85c0 1.19-.883 2.266-2.1 2.266q-.07-.002-.137-.008-.017.025-.037.05l-1.624 1.697a3 3 0 0 1-2.708 1.17 1.2 1.2 0 0 1-.709.224 1.2 1.2 0 1 1 1.193-1.415c.485-.045.95-.285 1.268-.704l1.443-1.51a2.36 2.36 0 0 1-.789-1.77V7.518c0-.913.52-1.757 1.31-2.102a4.8 4.8 0 0 0-9.212-.037c.842.318 1.401 1.19 1.401 2.139V9.85c0 1.19-.882 2.266-2.1 2.266S.55 11.041.55 9.851V7.518c0-1.01.635-1.937 1.571-2.195A6 6 0 0 1 7.95.75m-5.3 5.7c-.44 0-.9.417-.9 1.068V9.85c0 .65.46 1.066.9 1.066.439 0 .9-.417.9-1.066V7.518c0-.65-.461-1.068-.9-1.068m10.7 0c-.44 0-.9.417-.9 1.068V9.85c0 .65.46 1.066.9 1.066.439 0 .9-.417.9-1.066V7.518c0-.65-.461-1.067-.9-1.068" /></svg>;
}
;